import React, { useEffect, useState } from 'react';
import isNil from 'utils/isNil';
import DropdownSelect from 'components/DropdownSelect';
import { Row, Col } from 'antd';
import searchIcon from './icons/search-icon.svg';
import { Container, StyledTextField } from './styles';

const JobPostsFilters = ({ cards, setClickedJobIndex, setFilteredCards }) => {
  const [filterLocation, setLocation] = useState(null);
  const [filterTitle, setTitle] = useState(null);
  const [filterSearch, setSearch] = useState(null);

  const filtersExist = filterLocation !== null || filterTitle !== null || filterSearch !== null;
  const titleMenuItems = cards
    .filter(card => card.name)
    .map(card => card.name)
    .sort();

  useEffect(() => {
    setFilteredCards(getCards(cards));
    setClickedJobIndex(-1);
  }, [filterLocation, filterTitle, filterSearch, cards]);

  const locationsMenuItems = [
    ...new Set(
      cards
        .flatMap(x => x.jobs)
        .flatMap(x => x.locations)
        .map(x => x?.locationName)
        .sort()
    ),
  ];

  const handleSearch = (id, value) => setSearch(value);

  const getTerms = terms => {
    const lowerCaseTerms = term =>
      term &&
      term
        .split(' ')
        .map(word => word.toLowerCase())
        .join(' ');

    const formattedTerms = terms.filter(term => !isNil(term)).map(term => lowerCaseTerms(term));

    return formattedTerms;
  };

  const getJobTerms = (job, card) => {
    const jobTitle = job.title;
    const jobLocations = job.locations.map(x => x.locationName);
    const departmentTitle = card.name;

    return getTerms([departmentTitle, jobTitle, ...jobLocations]);
  };

  const getJobsWithFilterTerms = jobTerms => {
    const filterTerms = getTerms([
      locationsMenuItems[filterLocation],
      titleMenuItems[filterTitle],
      filterSearch,
    ]);

    return filterTerms.every(filterTerm => jobTerms.some(jobTerm => jobTerm.includes(filterTerm)));
  };

  const getCards = cards => {
    const labels = [];
    if (filtersExist) {
      return cards.reduce((allCards, card) => {
        card.jobs.forEach(job => {
          const jobTerms = getJobTerms(job, card);
          const jobIncludesFilter = getJobsWithFilterTerms(jobTerms);

          if (jobIncludesFilter) {
            if (!labels.includes(card.name)) {
              labels.push(card.name);
              allCards.push({ name: card.name, jobs: [] });
            }
            const parentCard = allCards.find(allCard => allCard.name === card.name);

            parentCard.jobs.push(job);
          }
        });

        return allCards;
      }, []);
    }
    return cards;
  };

  return (
    <Container>
      <Row align="middle" justify="center">
        <Col xs={24} lg={22} xl={18}>
          <Row className="job-posts-filters--filter-container">
            <Col xs={24} md={4} className="job-posts-filters--title">
              <h6>Search Jobs</h6>
            </Col>
            <Col xs={24} md={20}>
              <Row gutter={{ xs: 0, sm: 40, lg: 20 }}>
                <Col xs={24} sm={8}>
                  <DropdownSelect
                    id="locations"
                    clearable
                    label="Locations"
                    menuItems={locationsMenuItems}
                    handleSelect={setLocation}
                  />
                </Col>
                <Col xs={24} sm={8}>
                  <DropdownSelect
                    id="department"
                    clearable
                    label="Department"
                    menuItems={titleMenuItems}
                    handleSelect={setTitle}
                  />
                </Col>
                <Col xs={24} sm={8}>
                  <StyledTextField
                    id="search"
                    showOnlyFormError={true}
                    formErrors={false}
                    placeholder="Search"
                    handleChange={handleSearch}
                    suffix={<img src={searchIcon} />}
                    type="text"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default JobPostsFilters;
